module.exports = __webpack_public_path__ + "img/Onboarding1.2be09ea0.png";